import {Component, Input, OnInit} from '@angular/core';
import {ReferenceBookType, RefundResponse, RefundStatus} from '@npck/af-frontend-api';
import {DictionaryHolderService, findValueInDictionary} from '../../../../domain/dictionary-holder.service';

@Component({
    selector: 'af-refund-reject-panel',
    standalone: false,
    templateUrl: './refund-reject-panel.component.html',
})
export class RefundRejectPanelComponent implements OnInit {
    @Input() refund: RefundResponse;

    rejectReason: string;
    rejectionStage: RefundStatus;

    constructor(private dictionaryHolderService: DictionaryHolderService) {
    }

    ngOnInit(): void {
        this.dictionaryHolderService.getReference(ReferenceBookType.REJECT_TYPE)
            .subscribe(reference => {
                this.rejectReason = findValueInDictionary(reference, this.refund.rejectType, 'name_ru');
                if (this.refund.rejectedBin === this.refund.prosecutorOfficeBin) {
                    this.rejectionStage = RefundStatus.PENDING_APPROVAL;
                } else if (this.refund.rejectedBin === this.refund.receiverBin) {
                    this.rejectionStage = RefundStatus.PENDING_CONFIRMATION;
                } else if (this.refund.rejectedBin === this.refund.senderBin) {
                    this.rejectionStage = RefundStatus.IN_EXECUTION;
                } else {
                    this.rejectionStage = RefundStatus.REJECTED;
                }
            });
    }
}
